import { render, staticRenderFns } from "./object-card-hard-cameras.vue?vue&type=template&id=2f43c854&scoped=true&"
import script from "./object-card-hard-cameras.vue?vue&type=script&lang=js&"
export * from "./object-card-hard-cameras.vue?vue&type=script&lang=js&"
import style0 from "./object-card-hard-cameras.vue?vue&type=style&index=0&id=2f43c854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43c854",
  null
  
)

/* custom blocks */
import block0 from "./object-card-hard-cameras.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports